import { render, staticRenderFns } from "./InvoiceDetailsEmail.vue?vue&type=template&id=4efce49f&"
import script from "./InvoiceDetailsEmail.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports